import { Providers } from './Providers'
import { Router } from './Router'

/**
 * Application root component.
 *
 * Wraps `<Router>` inside `<Providers>` (QueryClient, AuthProvider,
 * ErrorBoundary). Mounted by `main.tsx` into the DOM root.
 */
export function App() {
  return (
    <Providers>
      <Router />
    </Providers>
  )
}
